import React, { useEffect } from "react";
import styles from "./style.module.css";
import Navbar from "../../components/Navbar/Navbar";
import DownloadButton from "../../components/DownloadButton";
import { images } from "../../assets/images";
import Section from "./components/Section";
import Pricing from "./components/Pricing";

import ContactUs from "./components/ContactUs";
import Footer from "../../components/Footer";

const LandlordScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  const { Apple, PlayStore } = images;
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  return (
    <div className={styles.mainContainer}>
      <Navbar text="Login/Sign In" />
      <div className={styles.container}>
        <svg
          className={styles.svg}
          width="1936"
          height="389"
          viewBox="0 0 1936 389"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.22623 238.513C125.184 144.385 238.268 334.715 359.074 186.169C529.722 -23.6659 551.501 198.737 966.406 137.594C1390.49 75.0982 1108.54 197.2 1504.4 261.367C1802.34 309.661 1904.78 171.937 1934.25 102.68"
            stroke="#F19223"
            stroke-opacity="0.15"
            stroke-width="3"
          />
          <path
            opacity="0.8"
            d="M3.2653 256.427C124.223 162.299 237.307 352.629 358.113 204.083C528.762 -5.75187 550.54 216.651 965.445 155.508C1389.53 93.0123 1107.58 215.114 1503.44 279.281C1801.38 327.575 1903.82 189.851 1933.29 120.594"
            stroke="#F19223"
            stroke-opacity="0.15"
            stroke-width="3"
          />
          <path
            opacity="0.5"
            d="M2.49967 270.759C123.458 176.63 236.541 366.961 357.347 218.414C527.996 8.57967 549.774 230.982 964.679 169.839C1388.76 107.344 1106.81 229.445 1502.68 293.612C1800.62 341.907 1903.06 204.183 1932.52 134.926"
            stroke="#F19223"
            stroke-opacity="0.15"
            stroke-width="3"
          />
          <path
            opacity="0.25"
            d="M1.67545 286.113C122.634 191.985 235.717 382.315 356.523 233.769C527.172 23.9342 548.95 246.337 963.855 185.194C1387.94 122.698 1105.99 244.8 1501.85 308.967C1799.79 357.261 1902.23 219.537 1931.7 150.28"
            stroke="#F19223"
            stroke-opacity="0.15"
            stroke-width="3"
          />
        </svg>

        <div className={styles.header}>
          <h1 className={styles.heading}>
            The ultimate fix for <br />{" "}
            <span className={styles.span}> property management </span>challenges
          </h1>
          <p className={styles.desc}>
            A software-as-a-service (SaaS) digital platform designed to automate
            and optimize the <strong> Operations,</strong>
            <strong> Finances </strong>and<strong> Management </strong>
            aspects of your rental property enterprises.
          </p>
          <div className={styles.buttonContainer}>
            <DownloadButton icon={Apple} text="Download on App Store" />
            <DownloadButton icon={PlayStore} text="Download on Play Store" />
          </div>
        </div>
      </div>

      <Section />
      <Pricing />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default LandlordScreen;
